import React from 'react';

export const RefundSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.125 4.37484H4.95833C2.70317 4.37484 0.875 6.203 0.875 8.45817C0.875 10.7133 2.70317 12.5415 4.95833 12.5415H9.04167"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2083 7.2915L13.125 4.37484L10.2083 1.45817"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);
